<template>
  <section>
    <v-dialog
      v-model="dialog"
      v-if="companySelected"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          text
          outlined
          height=50
          dark
          class="no-text-transform text-left pa-3 ml-5"
        > 
          <v-icon size=20 class="mr-2">mdi-cached</v-icon>
          {{companySelected.id}}
          Empresa: {{companySelected.M0_CODIGO}} - {{companySelected.M0_NOME}}
          <br/>
          Filial: {{companySelected.M0_CODFIL}} - {{companySelected.M0_FILIAL}}
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="grey darken-4 white--text">
          Seleção de Filial
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="companySelect"
            :items="companiesFiltered"
            item-value="id"
            return-object
            hide-details
            label="Empresa - Filial"
            class="mt-2"
          >
            <template v-slot:selection="{ item }">
              <v-chip link :color="item.empColor || 'grey darken-2'" dark label small class="mr-2"><v-icon small left>mdi-domain</v-icon> {{ item.M0_CODIGO }} - {{ item.M0_NOME }}</v-chip>
              <v-chip link :color="item.filColor || 'primary'" dark label small class="mr-2"><v-icon x-small left>mdi-home-city-outline</v-icon> {{ item.M0_CODFIL }} - {{ item.M0_FILIAL }}</v-chip>
            </template>
            <template v-slot:item="{ item }">
              <v-chip link :color="item.empColor || 'grey darken-2'" dark label small class="mr-2"><v-icon small left>mdi-domain</v-icon> {{ item.M0_CODIGO }} - {{ item.M0_NOME }}</v-chip>
              <v-chip link :color="item.filColor || 'primary'" dark label small class="mr-2"><v-icon x-small left>mdi-home-city-outline</v-icon> {{ item.M0_CODFIL }} - {{ item.M0_FILIAL }}</v-chip>
            </template>
          </v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="changeCompany({$router, company: companySelect}); dialog = false">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>      
  </section>
</template>

<script>
import { createNamespacedHelpers, mapState, mapActions } from 'vuex'
const { mapState:authState } = createNamespacedHelpers('auth')
export default {
  name: 'SelectEmpFil',
  data: () => ({
    dialog: false,
    companySelect: {}
  }),
  watch: {
    dialog(newValue) {
      if (newValue) this.companySelect = this.companySelected
    }
  },
  computed: {
    ...mapState(['companies', 'companySelected']),
    ...authState(['user']),

    companiesFiltered() { return this.companies.filter(x => this.user.companies.includes(x.id)) }
  },
  methods: {
    ...mapActions(['changeCompany']),
  },
}
</script>

<style>

</style>